<template>
  <el-dialog
    :title="`BOM表${ edit ? '配置': '查看' }`"
    :visible.sync="visible"
    width="900px"
    append-to-body
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      label-width="100px"
      :model="ruleForm">
      <el-form-item
        label="商品名称：">
        {{ product.productName }}
      </el-form-item>
      <el-form-item
        label="包装规格："
        :rules="[{required: true, message: '请输入包装规格', trigger: 'blur'}]"
        prop="corratio">
        <el-input-number
          v-if="edit"
          v-model="ruleForm.corratio"
          style="width:200px"
          :min="2"
          :precision="0"
          placeholder="请输入包装规格"></el-input-number>
        <span v-else>{{ ruleForm.corratio }}</span>
      </el-form-item>
      <el-form-item
        label="已选："
        required=""
        prop="list">
        <el-table
          ref="table"
          v-loading="loading"
          height="280"
          border
          :data="ruleForm.multipleSelection">
          <el-table-column
            label="原料名称"
            width="300"
            :resizable="false"
            prop="productName">
          </el-table-column>
          <!-- <el-table-column
            label="原料编号"
            width="80px"
            :resizable="false"
            prop="productNumber"></el-table-column> -->
          <el-table-column
            label="商品类别"
            width="120"
            :resizable="false"
            prop="productTypeName">
          </el-table-column>
          <el-table-column
            :resizable="false"
            label="数量">
            <template slot-scope="{row}">
              <template v-if="edit">
                <el-input-number
                  v-model="row.unitConsumption"
                  style="width:100%"
                  :min="0.1"
                  size="mini"
                  :precision="1"
                  placeholder="请输入数量"></el-input-number>
              </template>
              <span v-else>{{ row.unitConsumption }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="单位"
            :resizable="false"
            width="50"
            prop="measureUnit">
            <template slot-scope="{row}">
              {{ row.measureUnit | measureUnitName() }}
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
      <div v-show="edit">
        <el-divider>请从下方选择原料</el-divider>
        <el-form-item
          label="选择原料：">
          <el-table
            ref="table"
            v-loading="loading"
            height="320px"
            row-key="productId"
            border
            :data="ruleForm.list"
            @selection-change="handleSelectionChange">
            <el-table-column
              type="selection"
              reserve-selection
              width="40">
            </el-table-column>
            <el-table-column
              label="原料名称"
              :resizable="false"
              prop="productName">
              <template
                slot="header"
                slot-scope="scope">
                <el-input
                  v-model="config.productName"
                  clearable=""
                  :placeholder="`输入${scope.column.label}搜索`">
                  <el-button
                    slot="append"
                    icon="el-icon-search"
                    @click="fetchList"></el-button>
                </el-input>
              </template>
            </el-table-column>
            <!-- <el-table-column
            label="原料编号"
            :resizable="false"
            prop="productNumber"></el-table-column> -->
            <el-table-column
              label="商品类别"

              :resizable="false"
              prop="productTypeName">
              <template
                slot="header"
                slot-scope="scope">
                <el-select
                  v-model="config.productTypes"
                  :placeholder="`请选择${scope.column.label}`"
                  @change="fetchList">
                  <el-option
                    :key="1"
                    label="全部"
                    value="[2,3]">
                  </el-option>
                  <el-option
                    :key="3"
                    label="散茶"
                    value="[3]">
                  </el-option>
                  <el-option
                    :key="2"
                    label="包材"
                    value="[2]">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column
              label="单位"
              :resizable="false"
              width="100"
              prop="measureUnit">
              <template slot-scope="{row}">
                {{ row.measureUnit | measureUnitName() }}
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer">
      <el-button
        v-if="edit"
        type="primary"
        @click="addItem">更新</el-button>
      <el-button @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>

export default {
  name: 'BomModal',
  components: { },
  props: {
    callback: Function,
    edit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: false,
      ruleForm: {
        corratio: 1,
        bomId: null,
        list: [],
        multipleSelection: []
      },

      visible: false,
      config: {
        pageNum: 1,
        pageSize: 1000,
        productTypes: '[2,3]',
        productName: ''
      },
      option: null,
      product: {}
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.ruleForm = {
        corratio: 1,
        bomId: null,
        list: [],
        multipleSelection: []
      }
      this.option = null
      this.config.productTypes = '[2,3]'
      this.config.productName = ''
      this.product = {}
      this.$refs.table.clearSelection()
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('product/getproducts', {
        payload: {
          ...this.config,
          productTypes: JSON.parse(this.config.productTypes)
        },
        success: res => {
          this.loading = false
          this.ruleForm.list = res.data.records.map(i => {
            return {
              ...i,
              measureUnitName: i.measureUnit === 12 ? '件' : '克',
              productTypeName: i.productType === 2 ? '包材' : '散茶'
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch(row, option = {}) {
      // console.log(row, option)
      this.product = row
      this.option = option
      this.ruleForm.corratio = option.corratio || 1
      this.ruleForm.bomId = option.bomId || null
      this.toggleModal(true)
      this.$nextTick(() => {
        (option.bomDetails || []).map(i => {
          return {
            ...i,
            measureUnitName: i.measureUnit === 12 ? '件' : '克',
            productTypeName: i.productType === 2 ? '包材' : '散茶'
          }
        }).forEach(s => {
          console.log(s)
          this.$refs.table.toggleRowSelection(s, true)
        })
        this.fetchList()
      })
    },
    handleSelectionChange(val) {
      // console.log(val, '-----------------------handleSelectionChange')
      const multipleSelection = this.ruleForm.multipleSelection
      const result = val.map(i => {
        const item = multipleSelection.find(s => s.productId === i.productId)
        if (item) {
          return item
        } else {
          return {
            ...i,
            unitConsumption: i.unitConsumption || 1
          }
        }
      })
      this.$set(this.ruleForm, 'multipleSelection', result)
    },
    addItem() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const result = this.ruleForm.multipleSelection
          if (result.length === 0) {
            this.$message.error('请选择原料')
            return
          }
          const some = result.some(i => !i.unitConsumption)
          if (some) {
            this.$message.error('原料数量不能为空')
            return
          }
          this.loading = true
          const dispatch = this.ruleForm.bomId ? 'updatebom' : 'addbom'
          this.$store.dispatch('product/' + dispatch, {
            payload: {
              productId: this.product.productId,
              bomName: this.product.productName + '(BOM表)',
              corratio: this.ruleForm.corratio,
              bomId: this.ruleForm.bomId,
              bomDetails: result.map(i => {
                return {
                  productId: i.productId,
                  unitConsumption: i.unitConsumption
                }
              })
            },
            success: () => {
              this.loading = false
              this.toggleModal(false)
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
